import { RegularExpression } from "lib/data/transfer";

export class DataFieldType {
	public static readonly $type: string = "DataFieldType";
	public readonly $type: string = DataFieldType.$type;

	public id?: number;
	public name: string = "";
	public format: RegularExpression = new RegularExpression();
	public display: string = "";
	public mask?: string;
}
